export default __webpack_public_path__ + "static/3-a490b44471bc0ce6cfa4cf5f8369cfe5.jpeg";